import { render, staticRenderFns } from "./AudioRecording.vue?vue&type=template&id=517bddcb&scoped=true&"
import script from "./AudioRecording.vue?vue&type=script&lang=js&"
export * from "./AudioRecording.vue?vue&type=script&lang=js&"
import style0 from "./AudioRecording.vue?vue&type=style&index=0&id=517bddcb&prod&lang=scss&"
import style1 from "./AudioRecording.vue?vue&type=style&index=1&id=517bddcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517bddcb",
  null
  
)

export default component.exports